import { render, staticRenderFns } from "./RegionIndex.vue?vue&type=template&id=65ed4502&scoped=true"
import script from "./RegionIndex.vue?vue&type=script&lang=js"
export * from "./RegionIndex.vue?vue&type=script&lang=js"
import style0 from "./RegionIndex.vue?vue&type=style&index=0&id=65ed4502&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ed4502",
  null
  
)

export default component.exports